import { Transform } from 'class-transformer';
import { booleanTransform, dateTransform } from '../utils/helper';

export class Associate {
    id!: number;
    associatednumber!: number;
    @Transform(dateTransform)
    subscriptiondate!: Date;
    type?: string;
    section?: string;
    @Transform(booleanTransform)
    indicatore?: boolean;
    nazcardnumber?: number;
    cardnumber?: number;
    @Transform(dateTransform)
    terminationdate?: Date;
    terminationreason?: string;
    familycode?: number;
    cardcode?: number;
}

export function associate() {
	return Associate;
}